/* eslint no-bitwise: [2, { allow: ["|", "&"] }] */
import React, { Component } from 'react';

export default class Connatix extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    function uuidv5() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    }
    const RandID = uuidv5();
    window.top.document
      .getElementsByClassName('cnxtemp1')[0]
      .setAttribute('id', RandID);
    window.top.document.getElementById(RandID).removeAttribute('class');
    window.top.cnxps.cmd.push(() => {
      window.top
        .cnxps({ playerId: 'cc74fe14-ce4b-4396-96c1-972a4a1462a5' })
        .render(RandID);
    });
  }

  shouldComponentUpdate() {
    return false;
  }

  render() {
    return <script class="cnxtemp1" />;
  }
}
